<script lang="ts">
  import { session } from '../../../lib/auth.svelte';

  let {
    emoji = '🏥',
    title,
    subtitle = '',
    variant = 'admin',
  }: {
    emoji?: string;
    title: string;
    subtitle?: string;
    variant?: string;
  } = $props();

  const usuario = $derived(session.value?.usuario ?? 'Usuario');
  const tenant = $derived(session.value?.tenantId ?? '');
</script>

<div class="dash-hero hero-{variant}">
  <span class="dash-hero-emoji" aria-hidden="true">{emoji}</span>
  <div>
    <h1>{title}</h1>
    <p>{subtitle || `Bienvenido, ${usuario}`}{#if tenant} · {tenant}{/if}</p>
  </div>
</div>
